import React from 'react';
import { Heart } from 'lucide-react';

export const DonationsTab = ({ donations }) => (
  <div className="space-y-5">
    <h1 className="text-2xl font-bold text-gray-900">Dons</h1>
    {donations.length ? (
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Date</th>
              <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Montant</th>
              <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Type</th>
              <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Statut</th>
            </tr>
          </thead>
          <tbody>
            {donations.map(d => (
              <tr key={d.session_id || d.id} className="border-b border-gray-50">
                <td className="p-4 text-sm">{new Date(d.created_at).toLocaleDateString('fr-FR')}</td>
                <td className="p-4 text-sm font-bold">${d.amount}</td>
                <td className="p-4 text-sm text-gray-500">{d.label}</td>
                <td className="p-4">
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${d.payment_status === 'paid' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>
                    {d.payment_status === 'paid' ? 'Paye' : d.payment_status || 'En attente'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="bg-white rounded-2xl border border-gray-100 p-16 text-center">
        <Heart className="w-10 h-10 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-400 text-sm">Les dons apparaitront ici</p>
      </div>
    )}
  </div>
);
